import up from 'updeep';
import patch from './patch';
import { computeTakeActionResults } from './computeResults';
import { userPledgeStatus } from '../../lib/userApi';

/**
 * updateActionStatus will save action status to redux state, update calculator
 * answers, and perist user goals to user API.
 * @param {String} actionKey Calculator api key for action status. API key without
 * 'input_takeaction_' prefix.
 * @param {String} status Status to be saved through User API.
 */
export default (actionKey, status) => async (dispatch, getState) => {
  const { pledges } = getState();

  let apiValue = status === userPledgeStatus.PLEDGED ? '1' : '0';
  if (pledges[actionKey] === status) {
    apiValue = 0;
    dispatch(patch({
      pledges: up.omit(actionKey),
    }));
  } else {
    dispatch(patch({
      pledges: { [actionKey]: status },
    }));
  }

  await computeTakeActionResults({ [`input_takeaction_${actionKey}`]: apiValue })(dispatch, getState);
};
